import { authService } from "./App";
import { AuthHelper } from "./Helpers/AuthHelper";
import { AuthData } from "./Models/Auth/AuthData";
import { UserModelSalt } from "./Models/Auth/UserModelSalt";
import { AuthResultFromServer } from "./Providers/AuthResultFromServer";

let authResultFromServer: AuthResultFromServer = new AuthResultFromServer();

const authProvider = {
    isAuthenticated: false,
    authResultFromServer: authResultFromServer,

    async signin(authData: UserModelSalt, callback: VoidFunction) {
      var result = await AuthHelper.Login(authData)
      if (result != undefined){
        authProvider.isAuthenticated = true;
        authResultFromServer.passwordCorrect = true;
        authResultFromServer.token = result.token;
        authResultFromServer.expiresIn = result.expiresIn;
      }
      else{
        authProvider.isAuthenticated = false;
      }
      
      callback()
    },
    signout(callback: VoidFunction) {
      authProvider.isAuthenticated = false;
    },
  }
  
  export { authProvider as fakeAuthProvider };